import { useState } from "react";

// Pano adı artık panel oluşturulduğu kata göre otomatik üretiliyor
// (utils/panelNaming.js → buildDefaultPanelName, kullanıcı sonradan
// PanelTypeMenu üzerinden değiştirebilir). Buradaki "Pano Adı" inputu ve
// "Z.K.T." default'u otomatik isimlendirmeyi bozduğu için kaldırıldı.
export default function PanelDetails({ details, setDetails, onApply, mainPanelPhaseCount }) {
  const [showDetails, setShowDetails] = useState(true);

  return (
    <div className="panel-type-details-box">
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="my-button"
        style={{
          width: '100%',
          textAlign: 'left',
        }}
      >
        Pano Ekle {showDetails ? '▴' : '▾'}
      </button>

      {showDetails && (
        <div >
          <table className="panel-type-details-table compact-table">
            <tbody>
              <tr>
                <td className="label-cell">Abone Türü</td>
                <td>
                  <select
                    value={details.aboneTuru}
                    onChange={(e) => {
                      const newAboneTuru = e.target.value;
                      const updates = { ...details, aboneTuru: newAboneTuru };
                      if (newAboneTuru === "Ticari") {
                        updates.purposeOfUse = "İşYeri";
                      }
                      setDetails(updates);
                    }}
                  >
                    <option value="Mesken">Mesken</option>
                    <option value="Ticari">Ticari</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td className="label-cell">Kullanım Amacı</td>
                <td>
                  <select
                    value={details.purposeOfUse}
                    onChange={(e) => setDetails({ ...details, purposeOfUse: e.target.value })}
                  >
                    <option value="Mesken">Mesken</option>
                    <option value="İşYeri">İşyeri</option>
                    <option value="Müşterek">Müşterek</option>
                    <option value="Asansör">Asansör</option>
                  </select>
                </td>
              </tr>

 <tr>
  <td className="label-cell">Faz Sayısı</td>
  <td>
    <div style={{ display: 'flex', gap: '8px' }}>
      <label>
        <input
          type="radio"
          name="p_faz"
          value="1"
          checked={details.phaseCount === 1}
          onChange={() => setDetails({ ...details, phaseCount: 1 })}
        />
        1 Faz
      </label>
      <label title={details.phaseCount === 1 ? "Ana pano tek fazlı ise bu panel de 1 fazlı olmalıdır." : ""}>
        <input
          type="radio"
          name="p_faz"
          value="3"
          checked={details.phaseCount === 3}
          disabled={mainPanelPhaseCount === 1} // Bu prop da eklenmeli
          onChange={() => setDetails({ ...details, phaseCount: 3 })}
        />
        3 Faz
      </label>
    </div>
  </td>
</tr>


              <tr>
                <td colSpan={2}>
                  <button
                    onClick={onApply}
                    className="submit-button"
                    style={{ width: '100%' }}
                  >
                      Ekle
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
